// GENERATED FILE - do not edit by hand.
// Written by scripts/changelog/build.mjs from git history and docs/changelog/.
// Run "pnpm changelog:build" after committing to refresh it.

/** Current product version, derived from Conventional Commits (AGENTS.md §5). */
export const APP_VERSION = "0.1417.5";

/** How many changelog entries exist behind that version. */
export const CHANGELOG_ENTRIES = 4724;

/** When the two values above were last derived. */
export const VERSION_GENERATED_AT = "2026-11-05T14:46:42.194Z";
